// import isEmpty from 'validator/lib/isEmpty';
import { createField, updateField } from '../../actions';
import { EVENT_PASSWORD_INPUT, EVENT_STEP_VALIDATE } from '../../helpers/consts';
// const PasswordValidator = require('password-validator');

export class PasswordField {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.audit = options.audit;
        this.inputDelay = this.audit ? 200 : 210;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.$el = this.createFieldElement();

        if (this.value !== '' || !this.required) {
            this.update();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$buttonElem = document.createElement('button');
        const $buttonInnerElem = document.createElement('span');
        $buttonInnerElem.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" class="eye-closed" viewBox="0 0 20 9">
    <path d="M19.6450832.0987982c-.3501871-.20862191-.7937575-.06954063-.980524.25498235-.4202246.7185866-.9338324 1.39081278-1.5174776 1.99349832l-.116729.11590106c-.8871408.8808481-1.9377022 1.57625449-3.0816469 2.06303896l-.1400748.06954064c-1.1672905.48678447-2.4279642.7185866-3.7119837.74176682h-.14007483c-1.30736531 0-2.56803901-.25498235-3.75867528-.74176682l-.14007486-.06954064c-1.14394465-.48678447-2.19450606-1.18219086-3.08164681-2.06303896l-.11672905-.11590106c-.58364523-.60268554-1.09725303-1.2517315-1.5174776-1.9703181C1.13185649.02925756.71163193-.0866435.36144479.12197841c-.35018714.20862192-.46691619.62586575-.2568039.97356895.39687875.67222617.86379494 1.32127214 1.40074855 1.90077746L.52486545 4.68848038c-.21011228.3477032-.09338324.78812724.2568039.99674916.11672905.06954064.23345809.09272085.37353295.09272085.2568039 0 .49026199-.13908128.63033685-.37088341l.79375751-1.36763256c.72372009.62586575 1.54082341 1.15901065 2.40461835 1.57625448l-.46691618 1.66897534c-.09338324.39406362.11672904.78812724.5136078.88084809.07003743.02318021.11672904.02318021.18676647.02318021.32684133 0 .60699104-.20862191.70037428-.53314489l.39687875-1.50671385c.95717818.32452298 1.93770217.50996469 2.96491777.57950533V8.2814134c0 .39406362.32684133.7185866.7237201.7185866.3968787 0 .7237201-.32452298.7237201-.7185866V6.72833913c.980524-.06954064 1.9610479-.25498235 2.8948803-.55632512l.3968788 1.48353364c.0933832.32452298.3735329.53314489.7003742.53314489.0700375 0 .1167291 0 .1867665-.02318021.3968788-.09272085.6303369-.50996468.5136078-.88084809l-.4435703-1.66897534c.8637949-.41724383 1.6808982-.95038873 2.4046183-1.57625448l.7937575 1.34445235c.1400749.23180213.373533.37088341.6303369.37088341.116729 0 .2568039-.02318021.3735329-.09272085.3501871-.20862192.4669162-.64904597.2568039-.99674916l-.9571782-1.66897534c.5369536-.57950532 1.0038698-1.22855129 1.4007486-1.92395768.2334581-.3477032.116729-.78812724-.2334581-.97356894z"/>
</svg>
<svg xmlns="http://www.w3.org/2000/svg" class="eye-open" viewBox="0 0 86.6 57.1">
    <path d="M84.1 21.5C76.4 13.3 60.7-.4 42.6 0S9.5 15 2.1 23.6c-3 3.5-2.8 8.7.3 12 7.7 8.2 23.4 22 41.6 21.5 18.1-.5 33.1-15 40.4-23.6 3-3.5 2.9-8.6-.3-12zm-2.7 9.4C65.3 49.8 51 52.9 43.9 53.1S22.4 50.8 5.4 32.8c-1.7-1.9-1.8-4.7-.2-6.6C21.3 7.3 35.6 4.2 42.7 4c7.1-.2 21.5 2.2 38.5 20.3 1.7 1.8 1.8 4.7.2 6.6z"/>
    <path d="M43.3 8.8c-10.5 0-19.1 8.9-19.1 19.8s8.6 19.8 19.1 19.8 19.1-8.9 19.1-19.8S53.8 8.8 43.3 8.8zm0 35.5c-8.3 0-15.1-7.1-15.1-15.8S35 12.7 43.3 12.7s15.1 7.1 15.1 15.8-6.8 15.8-15.1 15.8z"/>
</svg>
        `;

        this.$buttonElem.type = 'button';
        this.$buttonElem.setAttribute('title', __('Show password'));
        this.$buttonElem.classList.add('btn');
        this.$buttonElem.tabIndex = -1;
        this.$buttonElem.classList.add('btn--toggle-password-visibility');
        $buttonInnerElem.classList.add('btn__inner');
        this.$buttonElem.appendChild($buttonInnerElem);

        this.$fieldInput.type = 'password';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.setAttribute('autocomplete', 'off');
        this.$fieldInput.setAttribute('aria-autocomplete', 'none');
        this.$fieldInput.value = this.value;
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--password');

        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', `field--${this.id}`, 'col-12', 'col-lg-6')
        $fieldLabel.classList.add('field-label');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$buttonElem);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', this.update.bind(this));
        this.$fieldInput.addEventListener('input', () => {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                this.update();
                this.value = this.$fieldInput.value;
                $field.dispatchEvent(EVENT_PASSWORD_INPUT);
            }, this.inputDelay);
        });

        this.$buttonElem.addEventListener('click', () => {
            if (this.$fieldInput.type === 'password') {
                this.$fieldInput.type = 'text';
                $field.classList.add('field--password--visible');
            } else {
                this.$fieldInput.type = 'password';
                $field.classList.remove('field--password--visible');
            }
        });

        return $field;
    }

    update() {
        this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default PasswordField;
